<template>
  <NForm ref="form" :model="model" :rules="rules" class="!grid-cols-1" @keydown.enter="onRegister()">
    <div class="n-invite-reg-content">
      <div class="n-invite-reg-inner">
        <div style="display: flex; align-self: flex-start; margin-left: 19px; margin-top: 20px">
          <img class="n-invite-reg-img1" src="/images/invite_reg/icon_1.png" />
          <label class="n-invite-reg-tx1">Astral</label>
        </div>
        <img class="n-invite-reg-img2" src="/images/invite_reg/icon_2.png" style="margin-bottom: 40px"/>

        <template v-if="haveShareCode">
          <div style="text-align: center;">
            <p style="max-width: 320px; margin: 0 auto">
              <span style="color: #ffffff; font-size: 19px">{{ $tl('inviteRegisterLogoTitle1') }}</span>
              <span style="color: #4285f4; font-size: 19px">{{ $tl('inviteRegisterLogoTitle2') }}</span>
            </p>
          </div>

          <div style="text-align: center; margin-top: 19px; margin-bottom: 24px">
            <p style="max-width: 320px; margin: 0 auto; line-height: 20px">
              <span style="color: #cccccc; font-size: 14px">{{ $tl('inviteRegisterLogoTitle3') }}</span>
              <span style="color: #4285f4; font-size: 14px">{{ $tl('inviteRegisterLogoTitle4', {address: invite_mask }) }}</span>
              <span style="color: #cccccc; font-size: 14px">{{ $tl('inviteRegisterLogoTitle5') }}</span>
            </p>
          </div>
        </template>

        <!-- 注册输入框 -->

        <NInput
          v-if="isMail"
          v-model:value="model.email"
          class="input n-invite-reg-input-box"
          name="email"
          :disabled="loading"
          :bordered="false"
          style="width: 324px"
          :placeholder="$tl('inviteRegisterPlaceholder1')"
        />

        <NInputPreSuffix
          v-if="isPhone"
          v-model:value="model.phone"
          class="input n-invite-reg-input-box n-invite-reg-prefix"
          name="phone"
          type="number"
          :disabled="loading"
          style="width: 324px"
          :placeholder="$tl('inviteRegisterPlaceholder2')"
        >
          <template #prefix>
<!--            <img style="width: 20px; height: 14px; margin-left: 10px" src="/images/invite_reg/icon_country_pt.png" />-->
<!--            <span style="color: #ffffff; font-size: 14px; margin-left: 5px; margin-right: 10px">+55</span>-->
            <NDropdown :trigger="['click']" placement="bottomRight">
            <span class="n-language-switcher grid grid-flow-col items-center gap-1 cursor-pointer auto-cols-max">
              <!--      <img :src="curLanguage.flag" width="30" />-->

              <img style="width: 20px; height: 14px; margin-left: 5px; margin-right: 5px;" :src="countryImgPath" />

              <span width="30" >{{model.countryCode}}</span>
              <DownOutlined />
            </span>

              <template #overlay>
                <NMenu @click="onCodeChange" class="n-invite-reg-mobile-box-flag-bg">
                  <NMenuItem v-for="item in countryCodeOptions2" :key="item.value">
                    <div class="grid grid-flow-col items-center gap-2 grid-cols-[1fr]">
                      <img :src="item.path" width="30" />
                      {{item.label}}
                    </div>
                  </NMenuItem>
                </NMenu>
              </template>
            </NDropdown>
          </template>
        </NInputPreSuffix>

        <NInputSafePassword
          v-model:value="model.password"
          class="input n-invite-reg-input-box n-invite-reg-safe-pwd"
          name="password"
          :disabled="loading"
          :bordered="false"
          style="width: 324px"
          type="password"
          :placeholder="$tl('inviteRegisterPlaceholder3')"
          show-password
        />

        <!-- 注册按钮 -->
        <NButton class="n-invite-reg-btn" @click="onRegister()">{{ $tl('inviteRegisterSubmit1') }}</NButton>

        <p style="margin-top: 27px">
          <span style="color: #656565; font-size: 14px">{{ $tl('inviteRegisterSeparateLine1') }}</span>
        </p>

        <!-- 注册切换按钮 -->
        <div style="display: flex; align-items: center; margin-top: 27px">
          <img
            :class="mailCSS"
            style="width: 35px; height: 35px; padding: 8px"
            src="/images/invite_reg/icon_email.png"
            @click="() => (model.providerType = 'MAIL_PASSWORD')"
          />
          <img
            :class="phoneCSS"
            style="width: 35px; height: 35px; margin-left: 40px; margin-right: 40px; padding: 8px 10px"
            src="/images/invite_reg/icon_phone.png"
            @click="() => (model.providerType = 'PHONE_PASSWORD')"
          />
          <img class="img5" style="width: 25px; height: 25px" src="/images/invite_reg/icon_google.png" @click="onGoogle()" />
        </div>

        <div style="text-align: center; margin-top: 37px">
          <p style="max-width: 320px; margin: 0 auto; line-height: 20px">
            <span style="color: #ffffff; font-size: 24px">{{ $tl('inviteRegisterPlatformLicence1') }}</span>
            <span style="color: #4285f4; font-size: 24px">{{ $tl('inviteRegisterPlatformLicence2') }}</span>
          </p>
        </div>
        <div class="n-invite-reg-box">
          <img src="/images/invite_reg/icon_6.png" />
          <span style="color: #ffffff; font-size: 14px; margin-top: 14px">{{ $tl('inviteRegisterPlatformBox1Title1') }}</span>
          <span style="color: #656565; font-size: 10px; margin-top: 14px">{{ $tl('inviteRegisterPlatformBox1Title2') }}</span>
        </div>
        <div class="n-invite-reg-box">
          <span
            style="
              width: 43px;
              height: 43px;
              padding: 7px;
              border: 1px solid #707070;
              border-radius: 6px;
              margin-top: 26px;
              color: #ffffff;
              font-size: 16px;
            "
            >0%</span
          >
          <span style="color: #ffffff; font-size: 14px; margin-top: 14px">{{ $tl('inviteRegisterPlatformBox2Title1') }}</span>
          <div style="text-align: center; margin-top: 10px">
            <p style="max-width: 220px; margin: 0px auto; line-height: 14px">
              <span style="color: #656565; font-size: 10px"
                >{{ $tl('inviteRegisterPlatformBox2Title2') }}</span
              >
            </p>
          </div>
        </div>
        <div class="n-invite-reg-box">
          <img src="/images/invite_reg/icon_7.png" />
          <span style="color: #ffffff; font-size: 14px; margin-top: 14px">{{ $tl('inviteRegisterPlatformBox3Title1') }}</span>
          <div style="text-align: center; margin-top: 10px">
            <p style="max-width: 220px; margin: 0px auto; line-height: 14px">
              <span style="color: #656565; font-size: 10px"
                >{{ $tl('inviteRegisterPlatformBox3Title2') }}</span
              >
            </p>
          </div>
        </div>

        <div class="n-invite-reg-box">
          <img src="/images/invite_reg/icon_8.png" />
          <span style="color: #ffffff; font-size: 14px; margin-top: 14px">{{ $tl('inviteRegisterPlatformBox4Title1') }} </span>
          <div style="text-align: center; margin-top: 10px">
            <p style="max-width: 220px; margin: 0px auto; line-height: 14px">
              <span style="color: #656565; font-size: 10px">{{ $tl('inviteRegisterPlatformBox4Title2') }}</span>
            </p>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 10px">
          <img style="width: 26px; height: 26px" src="/images/invite_reg/icon_9.png" />
          <img style="width: 55px; height: 35px; margin-left: 15px; margin-right: 10px" src="/images/invite_reg/icon_10.png" />
          <img style="width: 64px; height: 30px" src="/images/invite_reg/icon_11.png" />
          <img style="width: 81px; height: 24px; margin-left: 10px" src="/images/invite_reg/icon_12.png" />
          <img style="width: 80px; height: 27px" src="/images/invite_reg/icon_13.png" />
        </div>

        <div style="margin-top: 50px; margin-bottom: 45px">
          <div style="display: flex; justify-content: center">
            <div>
              <img
                fit="contain"
                style="width: 18px; height: 18px"
                :src="model.agree ? '/images/invite_reg/icon_oval_yes.png' : '/images/invite_reg/icon_oval_empty.png'"
                @click="() => {}"
              />
            </div>
            <div>
              <span style="font-size: 12px; color: #c2c2c2; margin-left: 8px; margin-right: 4px">{{$tl('inviteRegisterPrivacyPolicyTitle1')}}</span>
              <a href="https://astralw.com/privacy-policy" style="font-size: 12px; color: #4285f4">{{$tl('inviteRegisterPrivacyPolicyTitle2')}}</a>
            </div>
          </div>

          <div v-if="ttVisible" style="margin-top: 5px; text-align: center; color: var(--ant-error-color)">
            <span>{{ $tl('registerPleaseAgree') }}</span>
          </div>
        </div>
      </div>
    </div>
  </NForm>

  <!-- 验证码弹窗 -->
  <ADrawer
    :placement="placement"
    :closable="false"
    :visible="previewModalVisible"
    :autofocus="!verifyLoading"
    :mask-closable="!verifyLoading"
    class="n-invite-reg-bottom-modal-wrapper"
    :height="500"
    @close="onDrawerClose"
  >

    <div class="n-invite-reg-vc-popup-con">
      <div class="n-invite-reg-vc-popup-bottom_con">
        <img v-if="computeProviderType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD" src="/images/invite_reg/icon_reg_email.png" class="n-invite-reg-vc-popup-img" />
        <img v-if="computeProviderType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD" src="/images/invite_reg/icon_reg_phone.png" class="n-invite-reg-vc-popup-img" />
        <span v-if="computeProviderType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD" class="n-invite-reg-vc-popup-lab">{{ $tl('inviteRegisterVCodeDrawerTitleEmail') }}</span>
        <span v-if="computeProviderType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD" class="n-invite-reg-vc-popup-lab">{{ $tl('inviteRegisterVCodeDrawerTitlePhone') }}</span>

        <span style="color: #c1c1c1; font-size: 14px; padding: 5px 0">{{ reg_mask }}</span>
        <NInviteTimer :seconds="timer_count" @onResend="onResendCode" :loading="verifyLoading"/>

        <div v-if="resultNg.errorCode" style="margin-top: 5px; text-align: center; color: var(--ant-error-color)">
          <span>{{ t(resultNg.errorCode, PREFIX.ERROR_CODE) }}</span>
        </div>
        <NAsyncContainer :loading="verifyLoading" :blank="true">
          <NInviteVerifyCode :vv="previewModalVisible" :resend-time="vcResendTime" @afterFinished="afterVCFinish" />
        </NAsyncContainer>
      </div>
    </div>
  </ADrawer>
</template>

<script setup>
import {useAppAction, useBootstrap, useExecute, useLanguage, useModelPost, useRouter, useValidate} from '@front/hooks';
import { codeVerify, register, getAccountByCode, resendVerify } from '@front/api/utility';
import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { USERNAME_PROVIDER_TYPE, VALIDATION_RULE } from '@front/constant';
import {getDefaultAgent, getFrontURL, getMobiles} from '@/services';
import { isEmpty } from 'lodash-es';
import { Drawer as ADrawer } from 'ant-design-vue/es';
import { NForm } from '@/components';
import {generateMobiles, generateMobiles2, maskUsername} from "@front/utils";
//
const BRAZIL = 'BRAZIL';
const countryImgPath = ref("/images/invite_reg/icon_country_BRAZIL.png");
const sourceMobileOptions = getMobiles();
const countryCodeOptions2 = computed(() => { return generateMobiles2(sourceMobileOptions);});



const front = getFrontURL();
const defaultAgent = getDefaultAgent();
const agreeInitial = ref(true);
const { router, routerTo } = useRouter();
const { t, PREFIX, changeLanguage } = useLanguage();
const query = router.currentRoute.value.query;

const isMail = computed(() => model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD);
const isPhone = computed(() => model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD);
const mailCSS = computed(() =>
  model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD ? 'n-invite-reg-circle-bg-sel' : 'n-invite-reg-circle-bg-normal',
);
const phoneCSS = computed(() =>
  model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD ? 'n-invite-reg-circle-bg-sel' : 'n-invite-reg-circle-bg-normal',
);

const model = reactive({
  username: '',
  password: '',
  providerType: USERNAME_PROVIDER_TYPE.MAIL_PASSWORD,
  countryCode: '+55',
  country: BRAZIL,
  email: undefined,
  phone: undefined,
  agree: true,
  code: '',
});

const shareCode = computed(() => query?.shareCode ?? null);
const haveShareCode = computed(() => shareCode.value !== null);

const a = computed(() => query?.a ?? defaultAgent);
const ttVisible = computed(() => !model.agree && !agreeInitial.value);
const reg_mask = computed(() =>
  model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD ? model.email :  maskUsername( model.countryCode + model.phone, 3)
);
const computeProviderType = computed(() => model.providerType);
// +551234567890
const computeUsername = computed(() =>
    model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD ? model.email : model.countryCode + model.phone,
);
const invite_provider_type = ref(undefined);
const invite_username = ref(undefined);
const invite_mask = computed(() => invite_provider_type.value ===  USERNAME_PROVIDER_TYPE.MAIL_PASSWORD ? invite_username.value : computeMask.value);
const computeMask = computed(() => maskUsername(invite_username.value, 3));


const { setAction } = useAppAction();



const { form, loading, onPost } = useModelPost({
  post: customRegister,
});

const validation = computed(() => ({
  email: {
    required: model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD,
    isEmail: true,
    maxLength: VALIDATION_RULE.Customer.username.maxLength,
  },
  phone: {
    required: model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD,
    isMobile: true,
    maxLength: VALIDATION_RULE.Customer.mobile.maxLength,
  },
  countryCode: { required: model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD, maxlength: 5 },

  password: {
    required: true,
    maxLength: VALIDATION_RULE.Customer.password.maxLength,
  },
  providerType: { required: true },
  agree: { required: true },
}));

const {rules} = useValidate({formRef: form, validation});

const resultOk = reactive({
  success: false,
  agent: null,
});
const resultNg = reactive({
  success: false,
  errorCode: null,
  message: null,
});
const vcResendTime = ref(0);
const previewModalVisible = ref(false);
const placement = 'bottom';
const verifyLoading = ref(false);
const code = ref(undefined);
const intervalId = ref(undefined);
const isDev = import.meta.env.isDev;
const timer_count = ref(isDev ? 5 : 60);
const downloadLinks = reactive({});





onMounted(async () => {
  if(isDev){
    // changeLanguage('pt');
  }

  await getAccountInfo();
});

onUnmounted(() => {
  resetTimer();
});

watch(
  () => previewModalVisible.value,
  to => {
    if (to && previewModalVisible.value) {
      resetTimer();
      startTimer();
      resetResult();
    }
  },
  { immediate: true },
);

function onCodeChange(item, key, path) {
  const k = item.key;
  const v = sourceMobileOptions.find(s => s.code == k);
  model.country = v.country;
  model.countryCode = v.code;
  countryImgPath.value =  "/images/invite_reg/icon_country_"+v.country +".png"  ;

}

async function getAccountInfo(){
  const r = await getAccountByCode({shareCode: shareCode.value});
  if (r.data.success) {
    invite_username.value = r.data.username;
    invite_provider_type.value = r.data.providerType;
  }
}

async function customRegister() {
  const params = {
    username: computeUsername.value,
    type: model.providerType,
    password: model.password,
    shareCode: shareCode?.value ?? null,
    a: a?.value ?? null,
  };
  onFbEmailViewContent();

  // {"success":true,"data":{"success":true,"message":"成功"}}
  const result = await register(params);
  if (result.success) {
    previewModalVisible.value = true;
  }
}

async function onRegister() {
  setUpInitial();
  if (!model.agree) {
    return;
  }
  //
  await onPost();
}

function setUpInitial() {
  agreeInitial.value = false;
}

function onFbEmailViewContent() {
  window.fbq?.('track', 'Lead', { content_name: 'registration', contents: { channel: 'email', agent: a?.value ?? undefined } });
}

function onFbExternalViewContent(chn) {
  window.fbq?.('track', 'ViewContent', {
    content_name: 'registration',
    contents: { channel: chn, agent: a?.value ?? undefined },
  });
}

const onGoogle = () => {
  setUpInitial();
  if (!model.agree) return;
  setAction('REGISTER');
  const address = front + '/oauth2/authorization/google?action=QUICK_LOGIN&redirectUrl=' + front + '/%23/externalLoginVerify';
  const url1 = isEmpty(shareCode?.value) ? address : address.concat(`&shareCode=${shareCode.value}`);
  const url2 = isNaN(a?.value) ? url1 : url1.concat(`&a=${a.value}`);
  onFbExternalViewContent('google');
  window.open(url2, '_self');
};

function onDrawerClose() {
  previewModalVisible.value = false;
}

function onFbCompleteRegistration() {
  window.fbq?.('track', 'CompleteRegistration', {
    content_name: 'registration',
    contents: { channel: 'email', agent: resultOk.agent ?? undefined },
    status: true,
  });
}

async function afterVCFinish(vcode) {
  code.value = vcode;
  await execute();
}

const { execute } = useExecute({
  execute: async () => {
    try {
      verifyLoading.value = true;
      const r = await codeVerify({ code: code.value, username: computeUsername.value });

      resultOk.success = r.success;
      // 老黄说怕影响其他调用，目前只能这么改
      // resultOk.agent = r.data.message;
      resultOk.agent = r.data.agent;
      downloadLinks.iosAppLink = r.data.iosAppLink;
      downloadLinks.androidAppLink = r.data.androidAppLink;
      downloadLinks.windowsDesktopAppLink = r.data.windowsDesktopAppLink;
      downloadLinks.macX86DesktopAppLink = r.data.macX86DesktopAppLink;
      downloadLinks.macArmDesktopAppLink = r.data.macArmDesktopAppLink;
      downloadLinks.webLink = r.data.webLink;

      if (resultOk.success) {
        stopTimer();
        onFbCompleteRegistration();
        const encode_name = encodeURIComponent(computeUsername.value);
        routerTo('/inviteDownloads/' + encode_name);
        // TODO: for test errorCode
        // resultNg.errorCode = 'INVALID_ARGUMENT_RESOURCE_SAVE';
      }
    } catch (err) {
      resultNg.success = err.extra?.success;
      resultNg.errorCode = err.extra?.errorCode;
      resultNg.message = err.extra?.message;
    } finally {
      verifyLoading.value = false;
    }
  },
});

async function onResendCode() {
  try{
    vcResendTime.value = vcResendTime.value + 1;
    verifyLoading.value = true;
    const r = await resendVerify({ username: computeUsername.value });
    if (r.success) {
      timer_count.value = isDev ? 10 : 60;

      resetResult();
      startTimer();
    }
  }catch (err) {
    resultNg.success = err.extra?.success;
    resultNg.errorCode = err.extra?.errorCode;
    resultNg.message = err.extra?.message;
  } finally {
    verifyLoading.value = false;
  }
}

function startTimer() {
  intervalId.value = setInterval(() => {
    if (timer_count.value > 0) {
      timer_count.value = timer_count.value - 1;
    } else {
      // emits('timeOut');
      stopTimer();
    }
  }, 1000);
}

function stopTimer() {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = undefined;
  }
}

function resetTimer() {
  stopTimer();
  timer_count.value = isDev ? 10 : 60;
}
function resetResult() {
  resultNg.errorCode = null;
  resultNg.message = null;
  resultOk.success = false;
}
</script>

<style lang="less">

.n-invite-reg-content {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll !important;
  z-index: 1;
  background: linear-gradient(to bottom, #010b0b 10%, #0d233e 50%, #0d233d 80%, #010b0b 100%);
}

.n-invite-reg-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;

  .ant-btn {
    width: 324px;
    height: 54px;
    margin-top: 16px;
    font-size: 15px;
    border: none;
    color: white;
    background-color: #409eff;
  }

  .ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input,
  .ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover {
    background-color: inherit !important;
  }
  input:disabled {
    color: inherit !important;
  }
}

.n-invite-reg-img1 {
  width: 35px;
  height: 27px;
}

.n-invite-reg-tx1 {
  color: #ffffff;
  font-size: 20px;
}

.n-invite-reg-img2 {
  width: 135px;
  height: 144px;
  margin-top: 31px;
}

.n-invite-reg-box {
  width: 341px;
  height: 157px;
  background-color: #080808;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.n-invite-reg-box img {
  width: 43px;
  height: 43px;
  padding: 7px;
  border: 1px solid #707070;
  border-radius: 6px;
  margin-top: 26px;
}

.n-invite-reg-btn {
  width: 324px;
  height: 54px;
  margin-top: 44px;
  font-size: 15px;
  border: none;
  color: white;
  background-color: #409eff;
  border-radius: 5px;
}
.n-invite-reg-btn:active .n-invite-reg-btn:focus .n-invite-reg-btn:hover {
  width: 324px;
  height: 54px;
  margin-top: 44px;
  font-size: 15px;
  border: none;
  color: white;
  background-color: #409eff;
}

.n-invite-reg-circle-bg-sel {
  border-radius: 50%;
  background-color: #1a2d4f;
}

.n-invite-reg-circle-bg-normal {
  border-radius: 50%;
  background-color: #292929;
}

.n-invite-reg-input-box {
  color: white;
}

.n-invite-reg-input-box .ant-form-item-control-input {
  display: flex;
  align-items: center;
  width: 324px;
  height: 44px;
  border-radius: 5px;
  background-color: #f5f5f536 !important;
  color: white;
  border: none;
}

.n-invite-reg-input-box .ant-form-item-control .ant-form-item-explain .ant-form-item-explain-error {
  text-align: center;
}

.n-invite-reg-input-box .ant-form-item-control-input .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  width: 324px;
  height: 44px;
  border-radius: 5px;
  color: white;
  border: none;

  text-align: center;
}

.n-invite-reg-input-box
  .ant-form-item-control
  .ant-form-item-control-input
  .ant-form-item-control-input-content
  .n-invite-reg-prefix {
  display: flex;
  align-items: center;
  width: 50px;
  height: 44px;
  border-radius: 5px;
  background-color: inherit;
  color: white;
  border: none;
}

n-invite-reg-mobile-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 324px;
}

.n-invite-reg-input-box {
  .n-invite-reg-safe-pwd {
    input {
      color: white;
    }

    .ant-input-suffix {
      margin-right: 12px;

      svg {
        color: #a8abb2 !important;
      }
    }
  }
}

.n-invite-reg-prefix input {
  display: flex;
  align-items: center;
  background-color: transparent;
  color: white;
  border: inherit !important;
  padding: inherit !important;
}

.n-invite-reg-timer-box {
  font-size: 11px;
  margin-left: 10px;
  margin-top: 10px;
  text-align: center;
}

.n-invite-reg-bottom-modal-wrapper .ant-drawer-content {
  border-radius: 16px 16px 0 0;

}

/* popup */
.n-invite-reg-vc-popup-con {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
}

.n-invite-reg-vc-popup-bottom_con {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .ant-form-item {
    margin: 0 !important;
  }
}

.n-invite-reg-vc-popup-img {
  width: 43px;
  height: 42px;
  margin-top: 28px;
}
.n-invite-reg-vc-popup-lab {
  color: black;
  font-size: 12px;
  margin-top: 17px;
}

.n-invite-reg-button {
  background-color: #409eff !important;
  border: none;
  color: white !important;
  padding: 4px 8px;
  margin-left: 8px;
  border-radius: 4px;
  cursor: pointer;
}

.n-invite-reg-mobile-box-code {
  width: 94px !important;
  min-width: 94px !important;
}

.n-invite-reg-mobile-box-number {
  width: 220px;
  input {
    width: 220px;
  }
}
.n-invite-reg-mobile-box-flag-bg {
  background-color: #5c6a78 !important;
  .ant-dropdown-menu-item {
    .ant-dropdown-menu-title-content div {
      color:white !important;
    }
        }
}

</style>
